export default "__VITE_ASSET__34eccfdd__"